import getAppStoreBadge from "@helpers/getAppStoreBadge"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import getGooglePlayBadge from "../helpers/getGooglePlayBadge"

export default function GooglePlayAndAppStoreBadgeLinks() {
  const [googlePlayBadge, setGooglePlayBadge] = useState<string>("")
  const [appStoreBadge, setAppStoreBadge] = useState<string>("")

  useEffect(() => {
    const foo = async () => {
      const badge = await getAppStoreBadge()
      setAppStoreBadge(badge)
    }

    const bar = async () => {
      const badge = await getGooglePlayBadge()
      setGooglePlayBadge(badge)
    }

    void foo()
    void bar()
  }, [])

  if (!googlePlayBadge || !appStoreBadge) return null

  return (
    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-0">
      <Link
        className="justify-self-center"
        target="_blank"
        to={import.meta.env.VITE_APP_URL_GOOGLE_PLAY_STORE as string}
      >
        <img
          alt="Get Perfect Day on Google Play"
          className="h-[71px] sm:h-20"
          src={googlePlayBadge}
        />
      </Link>

      <Link
        className="justify-self-center"
        target="_blank"
        to={import.meta.env.VITE_APP_URL_APPLE_APP_STORE as string}
      >
        <img
          alt="Download Perfect Day on the App Store"
          className="h-20"
          src={appStoreBadge}
        />
      </Link>
    </div>
  )
}
